




import { Component, Vue, Prop } from 'vue-property-decorator'
import ActivityIndicatorDark from 'images/activity-indicator-dark.svg'
import ActivityIndicatorLight from 'images/activity-indicator-light.svg'
@Component({})
export default class SurfaceActivitySvg extends Vue {
  @Prop() colorScheme!: 'light' | 'dark'

  get svgPath(): string {
    return this.colorScheme === 'light' ? ActivityIndicatorLight : ActivityIndicatorDark
  }
}
